import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse, VisibaApiHttp } from '../../../Classes/visibaHttp.class';
import { DropInTicketApiModel as DropInEnqueueApiModel } from './Models/DropInTicketApiModel';
import { UserFileApiInput } from './Models/UserFileApiInput';

@Injectable()
export class DropInServiceV2 {
	readonly baseUri = '/api/Client/v2/DropIn';

	constructor(private http: VisibaApiHttp) {}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	public postEnqueue(dropInRoomId: number, model: any): Observable<ApiResponse<DropInEnqueueApiModel>> {
		model.LanguageCode = µ.Env.LangCode;

		return this.http.postTyped<DropInEnqueueApiModel>(`${this.baseUri}/${dropInRoomId}/tickets`, model);
	}

	public cancel(ticket: Guid): Observable<ApiResponse<void>> {
		return this.http.deleteTyped<void>(`${this.baseUri}/tickets/${ticket}`, true);
	}

	public getTicket(ticket: Guid): Observable<ApiResponse<DropInEnqueueApiModel>> {
		return this.http.getTyped<DropInEnqueueApiModel>(`${this.baseUri}/tickets/${ticket}`, true);
	}

	public getActiveTicket(): Observable<ApiResponse<DropInEnqueueApiModel>> {
		return this.http.getTyped<DropInEnqueueApiModel>(`${this.baseUri}/tickets/active`, true);
	}

	public getActiveRoomTicket(dropInRoomId: number): Observable<ApiResponse<DropInEnqueueApiModel>> {
		return this.http.getTyped<DropInEnqueueApiModel>(`${this.baseUri}/${dropInRoomId}/tickets/active`, true);
	}

	public upload(ticket: Guid, input: UserFileApiInput): Observable<ApiResponse<DropInEnqueueApiModel>> {
		return this.http.postTyped<DropInEnqueueApiModel>(`${this.baseUri}/tickets/${ticket}/files`, input, true);
	}
}
